import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";

const { Box, Heading, Text } = Chakra;

const SectionHeader = ({
  preheader,
  header,
  id,
  preheaderColor,
  children,
  dataTestId,
  preheaderSize,
  headerSize,
  ...props
}) => (
  <Box {...props}>
    {preheader && (
      <Text fontSize={preheaderSize} color={preheaderColor} textTransform="uppercase" fontWeight="bold" mb={4}>
        {preheader}
      </Text>
    )}
    <Heading variant="h2" as="h2" size={headerSize} id={id} data-testid={dataTestId}>
      {header}
      {children}
    </Heading>
  </Box>
);

export default SectionHeader;

SectionHeader.propTypes = {
  header: PropTypes.string.isRequired,
  preheader: PropTypes.string,
  id: PropTypes.string,
  preheaderColor: PropTypes.string,
  children: PropTypes.node,
  headerSize: PropTypes.string,
  preheaderSize: PropTypes.string,
  dataTestId: PropTypes.string,
};
SectionHeader.defaultProps = {
  preheader: "",
  id: null,
  preheaderColor: "primary.500",
  children: null,
  headerSize: "xl",
  preheaderSize: "md",
  dataTestId: "",
};
